export default __webpack_public_path__ + "static/media/pdf.139cc000.svg";